export enum PackageType {
	Zip,
	Debian,
}